export const SERVICE_NAME = 'outlook-app';
export const USER_TOKEN = 'userToken';
export const USER_NOT_FOUND_ERROR = 'User not found';
export const KUDOS_WEB_URL = 'https://give.kudosnow.com';
export const KUDOS_SUPPORT_URL = 'kudosnow.com';
export const KUDOS_TERMS_OF_USE = 'https://www.kudosnow.com/terms-of-service/';
export const KUDOS_SUCCESS_MESSAGE = 'Success! Your message has been sent 🚀';
export const NO_ACCOUNT_TITLE = 'It looks like you don\'t have a Kudos account';
export const ERROR_TITLE = 'Something went wrong  😕';
export const ERROR_DIALOG_TITLE = 'Error';
export const ERROR_MESSAGE = 'Please close the app and try again';
export const OPTIONS_DESCRIPTION = 'Send recognition to your colleagues! Select a level to get started.';
export const MAX_AVATARS_TO_SHOW = 3;
export const ATTACHMENT_HEIGHT = 184;
export const ATTACHMENT_NUM_OF_COLUMNS = 2.3;
export const STICKER_HEIGHT = 80;
export const STICKER_NUM_OF_COLUMNS = 3.3;
export const HOME_PAGE_FEED = '0';
export const TOO_MANY_ATTACHMENTS = 'You can not add more than 10 attachments';
export const ATTACHMENT_TOO_LARGE = (filename) => `${filename} is too large, max size is 150MB`;
export const UNSUPPORTED_ATTACHMENT = (filename) => `${filename} has an unsupported file type`;
export const ATTACHMENT_TOOLTIP = 'Attachment';
export const EMOJI_TOOLTIP = 'Emoji';
export const STICKERS_TOOLTIP = 'Stickers';
export const ATTACHMENT_SUPPORTED_TYPES = '(JPG, PNG, DOC, PDF, SVG, GIF)';
export const MESSAGE_LABEL = 'Write a message';
export const MESSAGE_PLACEHOLDER = 'Make it meaningful! Describe their actions and how they impacted you or the business.';
export const POST_PUBLIC = 'This post is public';
export const POST_PRIVATE = 'This post is private';
export const RECIPIENT_LABEL = 'Who do you want to recognize?';
export const RECIPIENT_OPTIONS_PLACEHOLDER = 'Start typing name, group, department, location, or email';
export const RECIPIENT_PLACEHOLDER = 'Start typing recipient(s)';
export const WALL_FEED_END_MESSAGE = 'Yay! You have seen it all';
export const CANCEL = 'Cancel';
export const SEND = 'Send';
export const QUALITIES_LABEL = 'Select qualities';
export const REFRESH = 'Refresh';
